const STATUS_LABELS: Record<string, string> = {
  unread: "نخوانده",
  reading: "در حال خواندن",
  read: "خوانده‌شده",
  want: "می‌خواهم",
  watch: "در حال تماشا",
  finished: "تمام‌شده",
  dropped: "رهاشده",
  visited: "بازدیدشده",
  again: "دوباره بروم",
  active: "فعال",
  paused: "متوقف",
  done: "انجام‌شده",
  purchased: "خریداری‌شده",
};

export function statusLabel(status: string | undefined): string | undefined {
  if (!status) return undefined;
  return STATUS_LABELS[status] ?? status;
}
